import { useEffect, useRef, useState } from "react";

interface TopbarProps {
  memberName: string;
  onLogout: () => Promise<void>;
}

export function Topbar({ memberName, onLogout }: TopbarProps) {
  const [open, setOpen] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const [logoutError, setLogoutError] = useState<string>();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const close = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setOpen(false);
        buttonRef.current?.focus();
      }
    };
    const closeOutside = (event: PointerEvent) => {
      if (
        event.target instanceof Node &&
        !menuRef.current?.contains(event.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("keydown", close);
    document.addEventListener("pointerdown", closeOutside);
    return () => {
      document.removeEventListener("keydown", close);
      document.removeEventListener("pointerdown", closeOutside);
    };
  }, [open]);

  const handleLogout = async () => {
    setLoggingOut(true);
    setLogoutError(undefined);
    try {
      await onLogout();
      setOpen(false);
    } catch {
      setLogoutError("登出失敗，請稍後再試。");
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    <header className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
      <div ref={menuRef} className="ml-auto position-relative">
        <button
          ref={buttonRef}
          className="btn btn-link"
          type="button"
          aria-haspopup="menu"
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          {memberName || "會員"}
        </button>
        {open && (
          <div className="dropdown-menu dropdown-menu-right show" role="menu">
            <button
              className="dropdown-item"
              type="button"
              role="menuitem"
              disabled={loggingOut}
              onClick={() => void handleLogout()}
            >
              {loggingOut ? "登出中…" : "登出"}
            </button>
            {logoutError && (
              <p className="dropdown-item-text text-danger mb-0" role="alert">
                {logoutError}
              </p>
            )}
          </div>
        )}
      </div>
    </header>
  );
}
